module.exports = __webpack_public_path__ + "img/new_index_cases15.d835f7c6.png";